import { type Insights, useInsights } from '@/modules/projects'
import { IncomeList } from '../components'
import { toChartData, toTableData } from '../components/IncomeList/utils'

export function IncomePage() {
  const insights = useInsights() as Insights
  const chartData = toChartData(insights.monthlyIncome)
  const tableData = toTableData(insights.monthlyIncome)

  return <IncomeList chartData={chartData} tableData={tableData} />
}
